import { render } from "./pqrDetail.vue?vue&type=template&id=556e37a6&scoped=true"
import script from "./pqrDetail.vue?vue&type=script&lang=js"
export * from "./pqrDetail.vue?vue&type=script&lang=js"

import "./pqrDetail.vue?vue&type=style&index=0&id=556e37a6&scoped=true&lang=css"

import exportComponent from "C:\\xampp-80\\htdocs\\v2crmred\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-556e37a6"]])

export default __exports__